import { AnyAction, Reducer } from '@reduxjs/toolkit';
import { PersistConfig, persistReducer, Transform } from 'redux-persist';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import storage from 'redux-persist/lib/storage'

export type OnahPersistConfig = Omit<PersistConfig<any, any, any, any>, 'storage'>;

const onahReducer = <T = any>(config: Omit<PersistConfig<any, any, any, any>, 'storage'>, baseReducer: Reducer<T, AnyAction>, encrypt = false) =>  {
    const transforms: Transform<any, any, T, any>[] = [];
    if(config.transforms) {
        transforms.push(...config.transforms);
    }
    if(encrypt) {
        transforms.push(
            encryptTransform({
            secretKey: process.env.REACT_APP_ENC_KEY ?? '',
            onError: function (error) {
              // Handle the error.
            },
          }),
        );
    }
    const reducer = persistReducer<T>(
      {
        ...config,
        storage: storage,
        transforms: transforms,
      },
      baseReducer
    );
    return reducer;
}

export default onahReducer;